import { Component, OnInit } from '@angular/core';
import { CommonMessageService } from 'src/app/services/common-message.service';
import { DiaryReportService } from 'src/app/services/diary-report.service';
import { MasterDataService } from 'src/app/services/master-data.service';
import { OrganizationSetupService } from 'src/app/services/organization-setup.service';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import * as moment from 'moment';
import { NgModel } from '@angular/forms';
import { BranchFilterService } from 'src/app/services/branch-filter.service';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: 'app-monthly-new-joinee-report',
  templateUrl: './monthly-new-joinee-report.component.html',
  styleUrls: ['./monthly-new-joinee-report.component.css']
})
export class MonthlyNewJoineeReportComponent implements OnInit {

  isBranchSelected: boolean;
  branchList;
  branchId;
  selectedBranch;
  monthList;
  fromMonthId: number;
  toMonthId: number;
  selectedMonth;
  financialList;
  selectedFinancialYear;
  monthlyNewJoineeReport = [];
  userRole;
  accessResponse: any;

  constructor(private masterDataService: MasterDataService,
    private diaryReportService: DiaryReportService, private commonMessageService: CommonMessageService,
    private organizationSetupService: OrganizationSetupService, private branchFilterService: BranchFilterService) { }

  ngOnInit(): void {
    this.selectedFinancialYear = "";
    this.selectedBranch = "";
    // this.selectedMonth="";
    this.fromMonthId = null;
    this.toMonthId = null;
    this.isBranchSelected = false;
    this.loadInitDetails();
  }

  getMonthlyNewJoineeReportdetails() {
    if (this.selectedFinancialYear == null ||
      this.selectedFinancialYear == undefined ||
      this.selectedFinancialYear == '' ||
      this.selectedBranch == null ||
      this.selectedBranch == undefined ||
      this.selectedBranch == '' ||
      // this.selectedMonth == null ||
      // this.selectedMonth == undefined ||
      // this.selectedMonth == ''
      !this.fromMonthId ||
      !this.toMonthId
    ) {
      this.commonMessageService.swalAlertWithoutIcon('', 'Please choose all the values');
      return;
    }

    const fromId = this.fromMonthId;
    const toId = this.toMonthId;

    const normalize = (id: number) => (id >= 4 ? id : id + 12);
    const isValid = normalize(toId) >= normalize(fromId);

    if (!isValid) {
      this.commonMessageService.swalAlertWithoutIcon(
        '',
        '"From Month" must be before or equal to "To Month"'
      );
      return;
    }

    this.branchId = this.selectedBranch.map(({ id }) => id);
    const fromMonthName = this.monthList.find(m => m.id === this.fromMonthId)?.name;
    const toMonthName = this.monthList.find(m => m.id === this.toMonthId)?.name;
    this.masterDataService
      .getMonthlyNewJoineeReport(this.selectedFinancialYear.id, this.branchId, fromMonthName, toMonthName)
      .subscribe((res: any) => {
        this.monthlyNewJoineeReport = res;
        console.log('this.monthlyNewJoineeReport', this.monthlyNewJoineeReport);
        if (this.monthlyNewJoineeReport.length > 0) {
          this.showExportToExcelButton = true;

        } else {
          this.commonMessageService.swalAlertWithoutIcon('', 'No Record Found.');
          this.showExportToExcelButton = false;

        }
      });

  }

  loadInitDetails() {
    this.accessResponse = JSON.parse(localStorage.getItem('accessResponse'));
    this.masterDataService.getFinancialYear().subscribe((res) => {
      this.financialList = res;
    });
    this.getBranchList();
  }

  getBranchList() {
    this.masterDataService.getBranch().subscribe((res) => {
      const branches = res as any[];
      const userBranchId = Number(localStorage.getItem('branchId'));

      this.branchList = this.branchFilterService.getFilteredBranches(branches, this.accessResponse, userBranchId);
    });
  }



  onFinancialYearSelected() {
    this.selectedBranch = "";
    // this.selectedMonth = "";
    this.fromMonthId = null;
    this.toMonthId = null;
    if (
      this.selectedFinancialYear != null &&
      this.selectedFinancialYear != undefined &&
      this.selectedFinancialYear != ''
    ) {

      this.monthList = [{ id: 1, name: 'January' }, { id: 2, name: 'February' }, { id: 3, name: 'March' }, { id: 4, name: 'April' }, { id: 5, name: 'May' }, { id: 6, name: 'June' }, { id: 7, name: 'July' }, { id: 8, name: 'August' }, { id: 9, name: 'September' }, { id: 10, name: 'October' }, { id: 11, name: 'November' }, { id: 12, name: 'December' }];
    }

  }

  selectAllBranch(select: NgModel, values) {
    this.selectAll(select, values, this.isBranchSelected, false);
    this.isBranchSelected = !this.isBranchSelected;

  }
  selectAll(select: NgModel, values, isSelected, isId) {
    if (!isSelected) {
      select.update.emit(values);
    } else select.update.emit([]);
  }


  userId;
  calculateAllTotal;


  showExportToExcelButton: boolean;
  onExportToExcelReport() {
    const fromMonthName = this.monthList.find(m => m.id === this.fromMonthId)?.name;
    const toMonthName = this.monthList.find(m => m.id === this.toMonthId)?.name;
    this.masterDataService.getMonthlyNewJoineeReportExcel(this.selectedFinancialYear.id, this.branchId, fromMonthName, toMonthName).subscribe((resp: any) => {
      const blob = new Blob([resp]); // you can change the type
      var downloadURL = window.URL.createObjectURL(blob);
      var link = document.createElement('a');
      link.href = downloadURL;
      link.download = "MonthlyJoineeReport.xlsx";
      link.click();
    });
  }

  // Helper method to get filtered months for toMonth dropdown
  getFilteredToMonths() {
    if (!this.fromMonthId || !this.monthList) {
      return this.monthList || [];
    }

    const normalize = (id: number) => (id >= 4 ? id : id + 12);
    const from = normalize(this.fromMonthId);

    return this.monthList
      .map(m => ({ ...m, order: normalize(m.id) }))
      .filter(m => m.order >= from)
      .sort((a, b) => a.order - b.order);
  }

  // Helper method to get filtered months for fromMonth dropdown
  getFilteredFromMonths() {
    if (!this.toMonthId || !this.monthList) {
      return this.monthList || [];
    }

    const normalize = (id: number) => (id >= 4 ? id : id + 12);
    const to = normalize(this.toMonthId);

    return this.monthList
      .map(m => ({ ...m, order: normalize(m.id) }))
      .filter(m => m.order <= to)
      .sort((a, b) => a.order - b.order);
  }

  // Reset toMonth when fromMonth changes and fromMonth > toMonth
  //   onFromMonthChange() {
  //   if (this.fromMonthId && this.toMonthId) {
  //     const normalize = (id: number) => (id >= 4 ? id : id + 12);
  //     const from = normalize(this.fromMonthId);
  //     const to = normalize(this.toMonthId);

  //     if (from > to) {
  //       this.toMonthId = null; 
  //     }
  //   }
  // }

  // Reset fromMonth when toMonth changes and fromMonth > toMonth
  onToMonthChange() {
    if (this.fromMonthId && this.toMonthId) {
      const normalize = (id: number) => (id >= 4 ? id : id + 12);
      const from = normalize(this.fromMonthId);
      const to = normalize(this.toMonthId);

      if (from > to) {
        this.fromMonthId = null;
      }
    }
  }


  exportToPDFClick() {
    var docDefinition = {
      info: { title: 'Monthly New Joinee Report' },
      pageOrientation: 'landscape',
      content: [
      ],
    };

    docDefinition.content.push({ text: 'P G BHAGWAT LLP, Chartered Accountants', fontSize: 14, bold: true, alignment: 'center' });
    docDefinition.content.push({ text: 'Suite 102, "Orchard", Dr Pai Marg, Baner, Pune - 411045', alignment: 'center' });
    docDefinition.content.push({ text: 'Monthly New Joinee Report', fontSize: 14, bold: true, alignment: 'center', margin: [0, 10, 0, 5] });

    for (let i = 0; i < this.monthlyNewJoineeReport.length; i++) {

      //   var totalAvailableArticle = 0;
      //   this.articleAvailabilityReport[i].details.map(res => {
      //     totalAvailableArticle += res.availableArticles;
      //   });
      docDefinition.content.push(' ');
      docDefinition.content.push({ columns: [{ text: `Branch:${this.monthlyNewJoineeReport[i].branch}`, fontSize: 12, bold: true, margin: [0, 0, 0, 5] },] });

      // docDefinition.content.push([{ text: `Reporting Partner:${this.articleAvailabilityReport[i].firstName} ${this.articleAvailabilityReport[i].lastName}`, fontSize: 12, bold: true, margin: [0, 0, 0, 5] }, { text: `Reporting Partner:${this.articleAvailabilityReport[i].firstName} ${this.articleAvailabilityReport[i].lastName}`, fontSize: 12, bold: true, margin: [0, 0, 0, 5] }])
      docDefinition.content.push({
        table: {
          headerRows: 1,
          widths: [200, '*', '*', '*', 150, '*'],
          body: [
            [{ text: 'Id', fillColor: '#17a2b8 !important', color: 'white', margin: [0, 5, 0, 5] },
            { text: 'Name', fillColor: '#17a2b8 !important', color: 'white', margin: [0, 5, 0, 5] },
            { text: 'Birth Date', fillColor: '#17a2b8 !important', color: 'white', margin: [0, 5, 0, 5] },
            { text: 'Joining Date', fillColor: '#17a2b8 !important', color: 'white', margin: [0, 5, 0, 5] },
            { text: 'Designation', fillColor: '#17a2b8 !important', color: 'white', margin: [0, 5, 0, 5] },
            { text: 'Monthly CTC Status', fillColor: '#17a2b8 !important', color: 'white', margin: [0, 5, 0, 5] },
            { text: 'Location', fillColor: '#17a2b8 !important', color: 'white', margin: [0, 5, 0, 5] }],
            ...this.monthlyNewJoineeReport[i].joineeDto.map((res: any) => [{ text: res.name }, { text: `${moment(res.birthDate).format('DD-MM-YYYY')}` }, { text: `${moment(res.joiningDate).format('DD-MM-YYYY')}` }, { text: res.designation }, { text: `${(res.ctcStatus == '') ? (res.stipendStatus) : (res.ctcStatus)}` }, { text: res.location }]),
          ]
        }
      }
      );
    }
    pdfMake.createPdf(docDefinition).download('MonthlyNewJoineeReport.pdf');
  }
}